/**
 * This class mimic the same behaviour as [GeolocationPositionError interface](https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError) but compatible on old devices such iOS < 10, where this interface doesn't expose.
 */
import { t } from 'utils/i18n';

class GeolocationPositionError extends Error {
  static PERMISSION_DENIED = 1;

  static POSITION_UNAVAILABLE = 2;

  static TIMEOUT = 3;

  constructor(error) {
    const { code, message } = error;
    super(message);

    this.message = this.getMessageByCode(code);
    this.code = code;
    this.name = 'GeolocationPositionError';
  }

  getMessageByCode = (code) => {
    switch (code) {
      case GeolocationPositionError.PERMISSION_DENIED:
        return t('permissionDenied');
      case GeolocationPositionError.POSITION_UNAVAILABLE:
        return t('positionUnavailable');
      case GeolocationPositionError.TIMEOUT:
        return t('positionTimeout');
      default:
        return t('geolocationNotSupported');
    }
  };
}

export default GeolocationPositionError;
